module.exports = __webpack_public_path__ + "static/media/certficate.cbea6ba5.jpeg";